/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import BaselineMoreVert from 'react-md-icon/dist/BaselineMoreVert';
import PropTypes from 'prop-types';

import './OptionsDropdown.scss';

const OptionsDropdown = ({
  items,
  toggleDropdown,
  isDropdownOpen,
}) => {
  let [dropdownOpen, setDropdownOpen] = useState(false);
  let toggle = () => setDropdownOpen(prevState => !prevState);

  // if user passed custom toggle functionality we need to use it instead of the hook
  if (toggleDropdown && isDropdownOpen !== null) {
    toggle = toggleDropdown;
    dropdownOpen = isDropdownOpen;
    setDropdownOpen = null;
  }

  return (
    <Dropdown id="kebab" isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle className="p-2">
        <BaselineMoreVert style={{ fontSize: '1.5rem' }} />
      </DropdownToggle>
      <DropdownMenu>
        {items.map((item, index) => {
          if (item === 'divider') {
            return (
              <DropdownItem className="my-2 mx-2" key={index} divider />
            );
          } else if (typeof item === 'object' && item !== null) {
            return item;
          } else {
            return (<DropdownItem onClick={() => toggle()} key={index}>{item}</DropdownItem>);
          }
          })}
      </DropdownMenu>
    </Dropdown>
  );
};

OptionsDropdown.defaultProps = {
  isDropdownOpen: null,
  toggleDropdown: null,
};

OptionsDropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isDropdownOpen: PropTypes.bool,
  toggleDropdown: PropTypes.func,
};

export default OptionsDropdown;



// WEBPACK FOOTER //
// ./src/components/OptionsDropdown/OptionsDropdown.jsx